<template>
	<div>
		<div v-if="courses">
			<div v-for="course in courses" :key="course.id" class="p-2">
				<b v-text="course.title"></b><br />
				<p v-html="course.description" class="small"></p>

				<div class="border-bottom pb-3 mb-2">
					<div v-if="override_subscriptions || course.user.has_subscription === 1" class="row">
						<div class="col-9">
							<div
								v-if="course.user.percent && parseInt(course.user.percent) === 100"
								class="text-right"
							>
								<small class="gold">Complete</small>
							</div>
							<b-progress
								:value="course.user.percent"
								max="100"
								height="5px"
								:variant="setBarColour(course.user.percent)"
							></b-progress>
							<div v-if="course.user.date && course.user.percent > 0" class="col-12 small">
								<small>Last accessed <b v-text="course.user.date"></b></small>
							</div>
						</div>
						<div class="col-3 text-right p-2">
							<a :href="'/course/' + course.id" class="btn btn-sm btn-outline-primary">
								take
							</a>
						</div>
					</div>

					<div v-else class="row">
						<div class="col-12">
							<div class="small text-warning">
								<i class="fas fa-alert"></i> You need a valid subscription to access this
								section
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from '@/axios';
//import CourseMeditation from '../components/CourseMeditation.vue';

export default {
	name: 'CourseCard',
	props: {
		data: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			courses: {},
			modal: {},
			page_loaded: 0,
			override_subscriptions: 1
		};
	},
	mounted() {
		this.courseGet();
	},
	methods: {
		courseGet() {
			console.log('courseGet');
			let _this = this;

			axios({
				method: 'post',
				url: 'coursesGet',
				data: { course_id: this.data.course_ids },
			})
				.then(function (response) {
					_this.courses = response.data.courses;
					_this.page_loaded = 1;
				})
				.catch(function (e) {
					console.log('Error: courseGet:' + e);
				});
		},

		openCourse(course_id) {
			console.log(course_id);
		},

		setBarColour(val) {
			var C = 'white_bgd';
			if (val >= 100) {
				C = 'gold_bgd';
			} else if (val >= 40) {
				C = 'cl_bg_blue';
			} else if (val > 0) {
				C = 'bronze_bgd';
			}
			return C;
		},
	},
	computed: {},
	watch: {},
};
</script>

<style scoped></style>
